import {RequestResult, RequestResultValue, NoContentResponse} from "../../common/api/requestResult";
import {HttpService} from "../../common/api/httpService";
import {JobsListResult} from "../../models/job";
import JSONbig from "json-bigint";

const JSONbigNative = JSONbig({ useNativeBigInt: true });

export async function jobsListApi(page: number, count: number, filterUserId: bigint, filterIsFailed: number, filterJobType: number)
    : Promise<RequestResultValue<JobsListResult>> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/jobs`, JSONbig.stringify(
        {
            page: page,
            count: count,
            isFailed: filterIsFailed > -1 ? filterIsFailed === 1 : undefined,
            userId: filterUserId > -1 ? BigInt(filterUserId) : undefined,
            jobType: filterJobType > -1 ? filterJobType : undefined
        }
    ));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<JobsListResult>(true, body as JobsListResult);
    }
    return new RequestResultValue<JobsListResult>(false);
}

export async function jobsRescheduleApi(jobId: string) : Promise<RequestResult> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/jobs/${jobId}/reschedule`, '{}');
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        const res = body as NoContentResponse;
        return new RequestResult(res.success);
    }
    return new RequestResult(false);
}